import 'url-search-params-polyfill';
require('array.prototype.find').shim();
require('array.prototype.findindex').shim();
require('array-includes').shim();
export default true;
